import React, { useEffect, useState, useMemo, useRef } from "react";
import styles from "./Hero.module.css";

const Hero: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const messageErrorIfTheBrowserNotSupport =
    "Your browser does not support the video tag.";

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    const playVideo = () => {
      if (video) {
        video.play().catch((error) => {
          // Autoplay was prevented. Handle the error here.
          console.error("Autoplay was prevented:", error);
        });
      }
    };

    // Attach playVideo to a user interaction event
    document.addEventListener("click", playVideo);

    return () => {
      document.removeEventListener("click", playVideo);
    };
  }, []);

  const renderTitle = useMemo(() => {
    if (windowWidth <= 1000) {
      return (
        <>
          <h1 className={styles.smallHeroTopTitle}>A Boutique</h1>
          <h1 className={styles.smallHeroSecondTitle}>Waterfront Camping</h1>
          <h1 className={styles.smallHeroThirdTitle}>Experience</h1>
        </>
      );
    } else {
      return (
        <>
          <h1 className={styles.largeHeroTopTitle}>A Boutique Waterfront</h1>
          <h1 className={styles.largeHeroSecondTitle}>Camping Experience</h1>
        </>
      );
    }
  }, [windowWidth]);

  return (
    <div className={styles.hero}>
      <div className={styles.videoContainer}>
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className={styles.fullscreenVideo}
        >
          <source
            src={
              "https://hero-video20842-staging.s3.amazonaws.com/hero_video_thehideawayretreat.mp4"
            }
            type="video/mp4"
          />
          {messageErrorIfTheBrowserNotSupport}
        </video>
      </div>
      <div className={styles.textWrapper}>{renderTitle}</div>
    </div>
  );
};

export default Hero;
